import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from "react-router-dom";
import Donation from "./Components/Donation";

// Composant wrapper pour gérer la langue via l'URL
const DonationWithLang = () => {
  const { lang } = useParams();
  const supportedLanguages = ['fr', 'en', 'es'];
  
  // Si la langue n'est pas supportée, rediriger vers FR
  if (lang && !supportedLanguages.includes(lang)) {
    return <Navigate to="/" replace />;
  }
  
  return <Donation lang={lang || 'fr'} />;
};

const App = () => {
  useEffect(() => {
    const handleOrientation = () => {
      if (window.innerHeight < window.innerWidth) {
        document.body.style.transform = "rotate(0deg)";
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.transform = "none";
        document.body.style.overflow = "auto";
      }
    };

    window.addEventListener("resize", handleOrientation);
    handleOrientation();

    return () => {
      window.removeEventListener("resize", handleOrientation);
    };
  }, []);

  return (
    <Router>
      <Routes>
        {/* Route principale (français par défaut) */}
        <Route path="/" element={<DonationWithLang />} />
        
        {/* Routes multilingues SEO-friendly */}
        <Route path="/:lang" element={<DonationWithLang />} />
      </Routes>
    </Router>
  );
};

export default App;